import React, { memo } from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import { Avatar } from '@mic3/platform-ui';

import { useImageExists } from 'app/utils/hook/hooks';

const AvatarStyled = styled(Avatar)`
    && {
        width: 64px;
        height: 32px;
        border-radius: 32px;
        margin-right: 8px;
    }
`;

const OrgAvatar = () => {
    const organisation = useSelector(state => state.app.organisation);
    const companyLargeLogo = useSelector(state => state.app.companyLargeLogo);
    const isMobile = useSelector(state => state.global.isMobile);
    const imageExists = useImageExists(companyLargeLogo);

    if (isMobile) {
        return null;
    }

    return (
        <>
            {imageExists ? (
                <AvatarStyled src={companyLargeLogo} size="lg" />
            ) : (
                <AvatarStyled size="lg" initials={organisation.name} />
            )}
        </>
    );
}

export default memo(OrgAvatar);